(function() {

  var truckSVG = '<svg style="width: 14px; height: 14px; fill: #28a745; flex-shrink: 0;" viewBox="0 0 640 512"><path d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"/></svg>';

  var eggCSS = '<style>@keyframes eggShake{0%{transform:rotate(-4deg)}8%{transform:rotate(5deg)}16%{transform:rotate(-5deg)}24%{transform:rotate(4deg)}32%{transform:rotate(-3deg)}40%{transform:rotate(4deg)}48%{transform:rotate(-4deg)}56%{transform:rotate(3deg)}64%{transform:rotate(-5deg)}72%{transform:rotate(5deg)}80%{transform:rotate(-4deg)}88%{transform:rotate(3deg)}96%{transform:rotate(-3deg)}100%{transform:rotate(-4deg)}}.egg-icon{animation:eggShake 0.8s ease-in-out infinite;transform-origin:center bottom}</style>';

  var eggSVG = '<svg class="egg-icon" style="width: 14px; height: 14px; fill: #28a745; flex-shrink: 0;" viewBox="0 0 384 512"><path d="M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0zm0 464c-79.5 0-144-64.5-144-144 0-84.6 59.4-240 144-240s144 155.4 144 240c0 79.5-64.5 144-144 144z"/><path d="M120 200l25-30 15 35-20 15zm80-50l30 20-15 25-25-15zm-50 80l-20 30 35-10 5-25zm90 40l20-25-30-5-10 35z" opacity="0.7"/></svg>';

  var excludedVendors = ["Strakkebus.nl", "PE Cosmetics Global", "studio monton", "housevitamin shop"];

  var days = ["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"];

  // TIJDELIJKE OVERRIDE — zet op true + vul deliveryDay in bij feestdagen
  var temporaryOverride = false;
  var overrideDay = "woensdag"; // alleen gebruikt als temporaryOverride = true

  function makeLabel(svgHTML, text) {
    return '<div style="color: #28a745; font-size: 12px; font-weight: 600; display: flex; align-items: center; gap: 4px; justify-content: flex-start; width: 100%; padding-left: 10px;">' +
      svgHTML +
      '<span>' + text + '</span>' +
      '</div>';
  }

  function getDeliveryDay(hasCutoff12) {
    if (temporaryOverride) {
      return overrideDay.charAt(0).toUpperCase() + overrideDay.slice(1);
    }

    var now = new Date();
    var dayOfWeek = now.getDay();
    var cutoffHour = hasCutoff12 ? 13 : 15;
    var deliveryDay = "";

    if (dayOfWeek >= 1 && dayOfWeek <= 3) {
      if (now.getHours() < cutoffHour) {
        deliveryDay = "morgen";
      } else {
        var datePlus2 = new Date(now);
        datePlus2.setDate(datePlus2.getDate() + 2);
        deliveryDay = days[datePlus2.getDay()];
      }
    } else if (dayOfWeek === 4) {
      if (now.getHours() < cutoffHour) {
        deliveryDay = "morgen";
      } else {
        deliveryDay = hasCutoff12 ? "morgen" : "zaterdag";
      }
    } else if (dayOfWeek === 5) {
      if (now.getHours() < cutoffHour) {
        deliveryDay = hasCutoff12 ? "morgen" : "morgen";
      } else {
        deliveryDay = "dinsdag";
      }
    } else {
      // zaterdag of zondag
      deliveryDay = "dinsdag";
    }

    return deliveryDay.charAt(0).toUpperCase() + deliveryDay.slice(1);
  }

  function initDeliveryLabels() {
    document.querySelectorAll('.delivery-label-pending').forEach(function(element) {

      // Markeer direct als verwerkt — voorkomt dubbele initialisatie
      element.classList.remove('delivery-label-pending');
      element.classList.add('delivery-label-done');

      var leverTag  = (element.dataset.leverTag || '').trim();
      var vendor    = (element.dataset.vendor || '').trim();
      var tags      = (element.dataset.tags || '').toLowerCase();

      // Centrale levertijd (snippets/ledplanet-levertijd + metaobjecten)
      if (window.LP_LEVERTIJD) {
        var lpTekst = window.LP_LEVERTIJD.kaartTekst({ vendor: vendor, template: element.dataset.template || '', profiel: element.dataset.profiel || '', bol: element.dataset.bol || '' });
        element.innerHTML = '';
        if (lpTekst) {
          var lpEgg = vendor === "Egglamp" || tags.indexOf('egglamp') !== -1;
          element.innerHTML = lpEgg ? eggCSS + makeLabel(eggSVG, lpTekst) : makeLabel(truckSVG, lpTekst);
        }
        return;
      }

      // Skip extern
      if (leverTag === "extern" || leverTag === "extern2-4wk") return;

      // Vaste levertijd leverancier
      if (leverTag === "blls 3-5") {
        element.innerHTML = makeLabel(truckSVG, '1-3 werkdagen');
        return;
      }

      // Egglamp
      if (vendor === "Egglamp" || tags.indexOf('egglamp') !== -1) {
        element.innerHTML = eggCSS + makeLabel(eggSVG, '2 - 8 werkdagen');
        return;
      }

      // Uitgesloten vendors
      if (excludedVendors.indexOf(vendor) !== -1) return;

      // Normale levertijd
      var hasCutoff12 = tags.indexOf('cutoff12') !== -1;
      var deliveryDay = getDeliveryDay(hasCutoff12);

      if (deliveryDay) {
        element.innerHTML = makeLabel(truckSVG, deliveryDay + ' in huis');
      }
    });
  }

  // Bij eerste load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryLabels);
  } else {
    initDeliveryLabels();
  }

  // Na bepalen land van de bezoeker / servertijd: labels opnieuw berekenen
  document.addEventListener('lp:levertijd-update', function() {
    document.querySelectorAll('.delivery-label-done').forEach(function(e) {
      e.classList.remove('delivery-label-done');
      e.classList.add('delivery-label-pending');
    });
    initDeliveryLabels();
  });

  // Bij Shopify sectie-events (theme editor, dynamic sections)
  document.addEventListener('shopify:section:load', initDeliveryLabels);

  // MutationObserver voor AJAX-gebaseerde cards (recently viewed, recommendations, etc.)
  var observer = new MutationObserver(function(mutations) {
    var hasNew = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        return n.nodeType === 1 && (
          (n.classList && n.classList.contains('delivery-label-pending')) ||
          (n.querySelector && n.querySelector('.delivery-label-pending'))
        );
      });
    });
    if (hasNew) initDeliveryLabels();
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();
